import React, {Component} from 'react'

class CommentSection extends Component {
    render() {
        return (
            <div className="commentSection">
                <h2>Let us know what you think</h2>
                {this.props.commentDiv}
            </div>
        )
    }
}

export default CommentSection